export default __webpack_public_path__ + "locales/hy-AM/VersionHistory.json?hash=e2eb2093daa1970ee7e9c527513c093f";